































import { Component, Vue, Prop } from 'vue-property-decorator';
import { TimelineItemViewModel, TimelineItemService } from '../../api/timelineItem';
import FileList from '../File/List.vue';
import MapList from '../Map/List.vue';
@Component({
  components: {
    FileList,
    MapList,
  },
})
export default class TimelineDetail extends Vue {
  private service: TimelineItemService = new TimelineItemService();
  private data: TimelineItemViewModel = this.service.NewModel;
  private timelineItemId: number = 0;
  private contentHeight: string = '500px';
  private created() {
    this.timelineItemId = parseInt(this.$route.query.id + '');
    this.service.Get(this.timelineItemId).then((response: any) => {
      this.data = response;
    });
  }
  private mounted() {
    this.contentHeight = (window.innerHeight - 60) + 'px';
  }
  private yearFormat(year: number) {
    return Math.abs(year) + '年 ' + (year < 0 ? 'BCE' : '');

  }
}
